import "../styles/main.css";
import "../styles/landing.css";
import "../styles/auth.css";
import "../styles/dashboard.css";

import { onAuthChange, signOut } from "./auth";
import { registerRoutes, startRouter, navigate, refreshRoute } from "./router";
import { renderLanding, mountLanding } from "./pages/landing";
import { renderLogin, mountLogin, renderSignup, mountSignup } from "./pages/login";
import { renderDashboard, mountDashboard } from "./pages/dashboard";
import { renderGettingStarted, mountGettingStarted } from "./pages/getting-started";
import { renderPrivacy, mountPrivacy } from "./pages/privacy";
import { renderTerms, mountTerms } from "./pages/terms";
import { renderHelp, mountHelp } from "./pages/help";

// Register all routes
registerRoutes([
  {
    path: "/",
    render: renderLanding,
    onMount: mountLanding,
  },
  {
    path: "/login",
    render: renderLogin,
    onMount: mountLogin,
  },
  {
    path: "/signup",
    render: renderSignup,
    onMount: mountSignup,
  },
  {
    path: "/dashboard",
    render: renderDashboard,
    onMount: mountDashboard,
    requiresAuth: true,
  },
  {
    path: "/getting-started",
    render: renderGettingStarted,
    onMount: mountGettingStarted,
  },
  {
    path: "/privacy",
    render: renderPrivacy,
    onMount: mountPrivacy,
  },
  {
    path: "/terms",
    render: renderTerms,
    onMount: mountTerms,
  },
  {
    path: "/help",
    render: renderHelp,
    onMount: mountHelp,
  },
]);

// Listen for auth state changes and update nav
onAuthChange((user) => {
  updateNav(!!user);
  refreshRoute();
});

function updateNav(loggedIn: boolean): void {
  // Elements that should show when NOT logged in
  const hideWhenAuth = document.querySelectorAll(".nav-auth-hide");
  // Elements that should show when logged in
  const showWhenAuth = document.querySelectorAll(".nav-auth-show");

  hideWhenAuth.forEach((el) => {
    (el as HTMLElement).style.display = loggedIn ? "none" : "";
  });

  showWhenAuth.forEach((el) => {
    (el as HTMLElement).style.display = loggedIn ? "" : "none";
  });
}

// Logout button
document.getElementById("nav-logout")?.addEventListener("click", async () => {
  await signOut();
  navigate("#/");
});

// Start the router
startRouter();
